import { AtividadeService } from './../../cadastros/atividade/atividade.service';
import { AreaTecnicaService } from './../../cadastros/areatecnica/areatecnica.service';
import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Photo } from '../../os/fechar-os/photo.model';
import { UploadPhoto } from '../../os/fechar-os/upload-photo.model';
import { ImagemUtil } from 'src/app/utils/Imagem.util';
import Swal from 'sweetalert2';
import { FecharOSService } from '../../os/fechar-os/fechar-os.service';
import { FotoBase64ViewModel } from '../../domain/viewmodels.models';
import { Util } from 'src/app/utils/util.util';
import { CommandResult } from '../../domain/commandResult';
import { OSService } from 'src/app/services/os-service';
import { SCAMP_API } from 'src/environments/environment';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
  selector: 'app-calendario-mensal',
  templateUrl: './calendario-mensal.component.html',
  styleUrls: ['./calendario-mensal.component.scss']
})

//202203221206
export class CalendarioMensalComponent implements OnInit, AfterContentInit {

  constructor(
    private formBuilder: FormBuilder,
    private areaTecnicaService: AreaTecnicaService,
    private atividadeService: AtividadeService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private fechamentoOSService: FecharOSService,
    private osService: OSService,
    private usuarioService: UsuarioService
  ) { }


  form: FormGroup = null;
  areasTecnicas: any[] = [];
  resultadosPesquisa: any[] = [];
  maskMesAno = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  isProcessing = false;
  atividadeSelecionada = null;

  // Fotos antes
  files: File[] = []; 
  previewsPhotos: Photo[] = []; 
  previewPhotoSelecionada: Photo; 
  photoForm: FormGroup;
  isLoadingRegistroFotografico: boolean = false;
  uploadPhotos: UploadPhoto[] = [];
  isRemoveProcessing: boolean;

  excelFileName: string = '';
  hrefExcelFile: string = '';

  public autorizacoes: UsuarioAutorizacoes;

  ngOnInit() {
    this.resetForm();
    this.resetPhotoForm();
    this.getAreasTecnicas();
  }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('calendario-mensal');
  }

  getAreasTecnicas() {

    this.areaTecnicaService.list().subscribe((response) => {
      this.areasTecnicas = response;
    })
  }

  changeMesAno() {

    const mesano = this.form.get('mesano').value;

    if (String(mesano).replace('_', '').length == 7) {
      const mes = mesano.split('/')[0];
      if (mes > 12 || mes == 0) {
        this.form.get('mesano').setErrors({isInvalidMesano: true})
      }
    } else {
      this.form.get('mesano').setErrors({isInvalidMesano: true})
    }
  }

  resetForm() {
    this.form = this.formBuilder.group({
      mesano: ['', [Validators.required]],
      areaTecnicaId: [0]
    })
  }

  resetPhotoForm() {
    this.photoForm = this.formBuilder.group({
      photo: ['', [Validators.required]]
    });
  }

  submit() {

    const  mesano =  String(this.form.get('mesano').value).replace('/', '');
    const areaTecnicaId = this.form.get('areaTecnicaId').value;

    if (mesano.includes('_')) {
      this.form.get('mesano').setErrors({isInvalidMesano: true});
      return;
    }

    this.isProcessing = true;
    this.resultadosPesquisa = [];
    this.excelFileName = '';
    this.hrefExcelFile = '';
   

    this.atividadeService.getAtividadeDetailsAsync(mesano, areaTecnicaId).subscribe( 
      (response) => {
        this.resultadosPesquisa = response;
        this.isProcessing = true;

        if (this.resultadosPesquisa.length == 0) {
          this.toastr.warning("Nenhum resultado encontrado com os parâmetros informados")
        }
    }, 
    (exception: any) => {
      this.showErrorExecption(exception);
      this.isProcessing = false;
    },
    () => this.isProcessing = false
    )
  }



  reset() {
    this.resetForm();
    this.isProcessing = false;
    this.resultadosPesquisa = [];

    this.files = [];
    this.resetPhotoForm();
    this.previewsPhotos = [];
    this.previewPhotoSelecionada = null;

    this.uploadPhotos = [];

  }



  showAtividade(atividadeId, modal: any) {

    if (this.resultadosPesquisa) {

      this.atividadeSelecionada = this.resultadosPesquisa.find(x => x.atividadeId === atividadeId);

      if (this.atividadeSelecionada != undefined) {
      
        this.previewsPhotos = [];
        this.previewPhotoSelecionada = null;
        this.files = [];

        if (this.atividadeSelecionada.uploadPhotos.length) {

         this.isLoadingRegistroFotografico = true;

         this.fechamentoOSService.getArrayFotosBase64(this.atividadeSelecionada.uploadPhotos).subscribe(
          (responseFotos: FotoBase64ViewModel[]) => {
            responseFotos.forEach(foto => {
              this.handleFile([].concat(Util.dataURLtoFile(foto.base64String, foto.arquivoNome)), false);
              this.previewsPhotos.push({ dataUrl: foto.base64String, name: foto.arquivoNome });
            });
            this.isLoadingRegistroFotografico = false;
          })

          this.modalService.open(modal, { windowClass: 'lgModal', backdrop: 'static' });
        } else {
          
          this.modalService.open(modal, { windowClass: 'lgModal', backdrop: 'static' });
        }

      } 
    
    }



  }

  submitPhoto(newFiles: File[]) {

    let uploadPhotos = [];

    let count = 0;
    
    if (newFiles.length > 0) {

      for (const f of newFiles) {

        count++;

        const uplodPhoto = {
          id: 0,
          arquivoNomeOriginal: f.name,
          arquivoNome: Util.getArquivoNome(this.atividadeSelecionada.atividadeId, count),
          osFechamentoId: null,
          spvId: null,
          atividadeId: this.atividadeSelecionada.atividadeId
        }

        uploadPhotos.push(uplodPhoto);
      }
    }


    this.atividadeService.uploadPhotos(uploadPhotos).subscribe( (uploadPhotosReturn) => {

      if (uploadPhotosReturn != null) {

        uploadPhotosReturn.forEach(x => this.atividadeSelecionada.uploadPhotos.push(x))
        
        this.fechamentoOSService.uploadPhotos(newFiles, uploadPhotos).subscribe(
          () => {
              this.toastr.success("Foto(s) salva(s) com sucesso!");
          },
          (exception: any) => {
            this.showErrorExecption(exception);
          }
        );
      }
    })
  }

  handleFile(files: File[], addPreviewsPhotos: boolean = true) {
    
    ImagemUtil.handleFile(files, this.files, this.previewsPhotos, this.isLoadingRegistroFotografico, addPreviewsPhotos);
    this.photoForm.get('photo').setValue('');

    if (this.atividadeSelecionada != undefined) {
      
    const newFiles = this.files.reduce( 
      (acumulador, atual) =>  this.atividadeSelecionada.uploadPhotos.some(a => a.arquivoNomeOriginal == atual.name)
                                                                         ? acumulador : acumulador.concat(atual) , []);

      if (newFiles.length > 0) {                                                                    
      this.submitPhoto(newFiles);
      }

    }
  }

  openModalExibePhoto(modal, pview) {
    this.previewPhotoSelecionada = pview;
    this.modalService.open(modal, { windowClass: 'zoomPhotoModal', backdrop: 'static' });
  }


  removerPhoto(name: string) {
    const uploadPhoto = this.atividadeSelecionada.uploadPhotos.find(t => t.arquivoNomeOriginal == name);
    this.removerPhotoPersistida(name, uploadPhoto.id)
  }

  public removerPhotoPersistida(name: string, uploadPhotoId: number) {

    Swal({
      title: 'Excluir',
      text: 'Deseja remover o registro fotográfico selecionado?',
      type: 'question',
      showCancelButton: true,
      cancelButtonText: 'Não',
      showConfirmButton: true,
      confirmButtonText: 'Sim',
      cancelButtonColor: '#d33',
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        this.delete(name, uploadPhotoId);
      }
    });

  }

  private delete(name: string, uploadPhotoId: number): void {

    this.isRemoveProcessing = true;

    this.osService.removerUploadPhoto(uploadPhotoId).subscribe(

      (response: CommandResult) => {

        const cmdResult = new CommandResult(response.success, response.message, response.notifications, response.data);

        if (cmdResult.success === true) {
          this.toastr.success(cmdResult.message);
          this.previewsPhotos = this.previewsPhotos.filter((photo: Photo) => photo.name !== name);
          this.files = this.files.filter(f => f.name !== name);
         
          this.submit();
        } else {
          this.toastr.warning(cmdResult.message);
        }

        this.isRemoveProcessing = false;
      },
      (exception: any) => {
        const cmdResult = new CommandResult(false, '', [], null);
        cmdResult.showErrorExecption(exception);
        this.isRemoveProcessing = false;
      },

      () => this.isRemoveProcessing = false

    );
  }


  exportarToExcel() {

    const  mesano =  String(this.form.get('mesano').value).replace('/', '');
    const areaTecnicaId = this.form.get('areaTecnicaId').value;

    if (mesano.includes('_')) {
      this.form.get('mesano').setErrors({isInvalidMesano: true});
      return;
    }

    this.isProcessing = true;
    this.excelFileName = '';
    this.hrefExcelFile = '';


    this.atividadeService.exportarCalendarioMensalToExcel(mesano, areaTecnicaId).subscribe(
      (response) => {

        if (response.success === true) {

          if (response.nenhumResultado === false) {

            this.excelFileName = response.fileName;
            this.hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`
          } else {
            this.toastr.warning(response.msgErro);
          }

          this.isProcessing = false;
        } else {

          this.toastr.error(response.msgException);
          this.isProcessing = false;
        }
      }
    )
  }

  

 


  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
    if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }
    this.toastr.error(`<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`);
  }
}
